import io from 'socket.io-client';
import feathers from '@feathersjs/client/dist/feathers.min.js';
import socketio from '@feathersjs/client/dist/socketio.min.js';
import auth from '@feathersjs/client/dist/authentication.min.js';
import config from '@/config';

const socket = io(config.server_url);
export const client = feathers();

try {
  client
    .configure(
      socketio(socket, {
        timeout: config.socket_timeout
      })
    )
    .configure(
      auth({
        storage: window.localStorage
      })
    );

  // Add global error hook to handle session invalidation
  client.hooks({
    error: {
      all: [
        context => {
          const error = context.error;
          // Check for NotAuthenticated error
          if (error && error.name === 'NotAuthenticated') {
            const errorMessage = error.message || '';

            // Handle session invalidation or no auth token
            if (
              errorMessage.includes('Session invalidated') ||
              errorMessage.includes('password change') ||
              errorMessage.includes('No auth token') ||
              errorMessage.includes('jwt expired') ||
              errorMessage.includes('invalid token')
            ) {
              console.log('Feathers: Authentication failed - redirecting to login');

              // Clear local storage and cookies
              localStorage.removeItem('feathers-jwt');
              localStorage.removeItem('SELECTED_CMS_VENUE');
              document.cookie = 'feathers-jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';

              // Logout from client
              try {
                client.logout();
              } catch (e) {
                // Ignore logout errors
              }

              // Force redirect to login page immediately
              window.location.replace('/');
            }
          }
          return context;
        }
      ]
    }
  });
} catch (error) {
  console.error('Error configuring Feathers client:', error);
}

import Vue from 'vue';
export const conversionEventBus = new Vue();

socket.on('connect', () => {
  setupConversionListeners();
});

socket.on('reconnect', () => {
  setupConversionListeners();
});

function setupConversionListeners() {
  socket.off('conversion:start');
  socket.off('conversion:progress');
  socket.off('conversion:complete');
  socket.off('conversion:error');

  socket.on('conversion:start', data => {
    conversionEventBus.$emit('conversion:start', {
      id: `conversion_${data.filename}`,
      name: `Converting ${data.originalFileName || data.filename}`,
      message: 'Converting H.265 to H.264...'
    });
  });

  socket.on('conversion:progress', data => {
    conversionEventBus.$emit('conversion:progress', {
      id: `conversion_${data.filename}`,
      progress: data.progress,
      name: data.originalFileName || data.filename
    });
  });

  socket.on('conversion:complete', data => {
    conversionEventBus.$emit('conversion:complete', {
      id: `conversion_${data.filename}`,
      message: `${data.originalFileName || data.filename} converted successfully!`
    });
  });

  socket.on('conversion:error', data => {
    conversionEventBus.$emit('conversion:error', {
      id: `conversion_${data.filename}`,
      message: `Failed to convert ${data.originalFileName || data.filename}: ${data.error}`
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/index.js